module.exports = __webpack_public_path__ + "static/media/implements.66cc2095.png";